/**
 * @file tipAmountFormat.js
 * @description 打赏档位展示文案（分 → 元/分）
 * @module features/comic/utils/tipAmountFormat
 */

/**
 * 将分转为展示文案
 * @param {number} amountCent
 * @returns {string}
 */
export function formatTipAmountCent(amountCent) {
  const cents = Number(amountCent)
  if (!Number.isFinite(cents) || cents <= 0) return ''
  if (cents < 100) return `${cents}分`
  if (cents % 100 === 0) return `¥${cents / 100}`
  return `¥${(cents / 100).toFixed(2)}`
}

/**
 * 打赏档位按钮/摘要文案：优先 name，否则按分格式化
 * @param {{ name?: string, amountCent?: number }} option
 * @returns {string}
 */
export function formatTipAmountLabel(option) {
  const name = typeof option?.name === 'string' ? option.name.trim() : ''
  if (name) return name
  return formatTipAmountCent(option?.amountCent ?? 0)
}
